import { useEffect } from 'react';
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';
import { Header } from './Header';
import { Navigation } from './Navigation';

export function RootLayout() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  const isMovieDetail =
    Boolean(matchPath('/movie/:id', location.pathname)) ||
    Boolean(matchPath('/movie/:id/*', location.pathname));

  return (
    <div className="h-screen overflow-y-auto overflow-x-hidden scrollbar-hide bg-bg-primary text-white">
      {!isMovieDetail && <Header />}
      <main className={isMovieDetail ? '' : 'pb-20'}>
        <Outlet />
      </main>
      {!isMovieDetail && <Navigation />}
    </div>
  );
}
